import { Injectable } from '@angular/core';
import { HttpDataService } from '../../../../shared/http/http-data.service';

import { IProfileAttributeRequest, IProfileAttributeResponse, ProfileAttributeStatusIcon } from '../../profile-attributes/bp-profiles-attributes.service';
import { IStatusIconLegend } from '../../bp-profiles.service';

@Injectable()
export class BPProfilesTCDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /**/
  }

  public get tcLegends():IStatusIconLegend[] {
    return [
      { iconClass: ProfileAttributeStatusIcon.OK, label: 'BPPROFILES.TC.ICON_INFO.OK' },
      { iconClass: ProfileAttributeStatusIcon.WARNING, label: 'BPPROFILES.TC.ICON_INFO.WARNING' },
      { iconClass: ProfileAttributeStatusIcon.CRUCIAL, label: 'BPPROFILES.TC.ICON_INFO.CRUCIAL' },
      { iconClass: ProfileAttributeStatusIcon.INVALID, label: 'BPPROFILES.TC.ICON_INFO.INVALID' }
    ];
  }

  public loadTC(bpProfileId:number):Promise<IProfileAttributeResponse> {
    return this.httpDataService.doGET(
      `rest/bpprofiles/profiles/${bpProfileId}/termsandconditions`,
      undefined,
      undefined,
      'Error loading terms and conditions'
    );
  }

  public saveTC(bpProfileId:number, data:IProfileAttributeRequest[]):Promise<IProfileAttributeResponse> {
    return this.httpDataService.doPUT(
      `rest/bpprofiles/profiles/${bpProfileId}/termsandconditions`,
      undefined,
      data,
      undefined,
      'Error saving terms and conditions'
    );
  }
}